module.exports = __webpack_public_path__ + "static/media/musician.a9bf4a15.jpg";